let state = {
  modalZIndex: 8000, // 当前层级
  modal: '', // modal节点
  dialogList: [], // dialog节点
  delModal() { // 删除dialog
    let dialog = this.dialogList.pop()
    if (this.dialogList.length > 1) { // dialog没有删除完则modal层级改变
      this.modal.style['z-index'] = Number(this.dialogList[this.dialogList.length - 1].getAttribute('wf-index')) - 1
      return
    } else {
      document.body.removeChild(this.modal)
      this.modal = ''
    }
    setTimeout(() => {
      document.body.removeChild(dialog)
    }, 300)
  },
  modalInit() { // modal初始化
    if (this.modal) {
      this.modal.style['z-index'] = this.modalZIndex - 1
      return
    }
    const div = document.createElement('div')
    div.className = 'wf-modal'
    div.style['z-index'] = this.modalZIndex - 1
    document.body.appendChild(div)
    this.modal = div
  },
  addModalIndex(el) {
    this.modalZIndex = this.modalZIndex + 1 // 记录的层级
    this.dialogList.push(el)
    el.style.zIndex = this.modalZIndex // 赋值当前最新层级
    el.setAttribute('wf-index', this.modalZIndex)
    this.modalInit()
  }
}
export default state
